import React from "react";
import "../styles/DueDiligence.css";

const StatsCard = ({ icon, value, label, bg }) => {
  return (
    <div className="stats-card"  style={{ "--card-bg": bg }}>
      <div>
        <img className="stats-icon" src={icon} alt={label} />
      </div>
      <div>
        <div className="stats-value">{value}</div>
        <div className="stats-label">{label}</div>
      </div>
      <div className="stats-card-circles">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
      </div>
    </div>
  );
};

export default StatsCard;
